export const MESSAGE_DIRECTION = {
  INBOUND: 'inbound',
  OUTBOUND: 'outbound',
  UNKNOWN: 'unknown',
} as const;

export const PARTICIPANT_TYPE = {
  AGENT: 'agent',
  CUSTOMER: 'customer',
} as const;

export const PARTICIPANT_DISPLAY_NAME = {
  AGENT: 'Agent',
  CUSTOMER: 'Customer',
} as const;

export const PROCESSING_STAGE = {
  SENDING: 'sending',
  GENERATING: 'generating',
  COMPLETED: 'completed',
  ERROR: 'error',
} as const;

export const PROCESSING_STATUS = {
  WAITING_FOR_RESPONSE: 'waiting for response',
  RESPONSE_READY: 'response ready',
} as const;

export const WS_MESSAGE_TYPE = {
  PING: 'ping',
} as const;

export const GENESYS_CLOUD = {
  TOPIC_NAME: 'v2.detail.events.conversation.messaging',
  CHANNEL_METADATA: 'channel.metadata',
} as const;

export const CLOUD_EVENT = {
  SPEC_VERSION: '1.0',
  TYPE: 'v2.users.conversations.events',
  SOURCE: 'genesys-cuca-frontend',
  CONTENT_TYPE: 'application/json',
  EVENT_BODY: 'eventBody',
  CONVERSATION_START_TYPE: 'conversation-start',
  CONVERSATION_PARTICIPANT_EVENTS: 'conversation-participant-events',
  CONVERSATION_ACW_EVENTS: 'conversation-acw-events',
} as const;

export const USER_DISPLAY_NAMES = {
  AGENT: 'Agent',
} as const;

export type MessageDirection =
  (typeof MESSAGE_DIRECTION)[keyof typeof MESSAGE_DIRECTION];
export type ProcessingStage =
  (typeof PROCESSING_STAGE)[keyof typeof PROCESSING_STAGE];
